import { render, staticRenderFns } from "./CopyElementModal.vue?vue&type=template&id=d9a5f748&scoped=true&"
import script from "./CopyElementModal.vue?vue&type=script&lang=ts&"
export * from "./CopyElementModal.vue?vue&type=script&lang=ts&"
import style0 from "./CopyElementModal.vue?vue&type=style&index=0&id=d9a5f748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a5f748",
  null
  
)

export default component.exports